import React from "react";
import "./CSS/FounderSection.css";
import founderImg from "./IMAGES/Component 31.png";

const FounderSection = () => {
  return (
    <div className="founder-container">
      <div className="founder-card">
         <span className="corner-top-right"></span>
  <span className="corner-bottom-left"></span>
        <div className="founder-image">
          <img src={founderImg} alt="Founder" />
        </div>

        <div className="founder-content">
          <p className="quote">
           At Sapra – we personally believe fashion is not just about clothes.
It is about expressing who you are, refined elegance, and style. I am deeply passionate about staying ahead of the latest trends, and I want all my royal customers to carry themselves with that same level of confidence.
          </p>

          <p className="author">
            Prachi Kunjir - Founder & CEO, SaPra House of Élan
          </p>
        </div>

      </div>
    </div>
  );
};

export default FounderSection;